import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import BackBar from "@/components/BackBar";

export default function ComingSoon() {
  const { t } = useI18n();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen flex flex-col"
      style={{ background: "var(--tg-bg)" }}
    >
      <BackBar to="/home" />
      <div className="flex-1 flex flex-col items-center justify-center gap-4 px-8">
        <span className="text-5xl">🚧</span>
        <p className="text-xl font-semibold text-center" style={{ color: "var(--tg-text)" }}>
          {t("coming_soon")}
        </p>
      </div>
    </motion.div>
  );
}
